<template>
  <div id="app">
    <!-- <nav class="navbar navbar-expand navbar-dark bg-dark static-top">

    <a class="navbar-brand mr-1" href="index.html">Start Bootstrap</a>

    </nav>-->
    <b-navbar class="mainbar" toggleable="lg" type="dark">
      <!-- <div
        style="background-color: #fff; padding: 10px; width: 86px; min-width: 86px; max-width: 86px;"
      > -->
      <b-navbar-brand href="/homepage" style="margin: 0px 18px 0px 2px;">
        <img
          src="./assets/Logo/MeGroup_logo.png"
          class="d-inline-block align-top"
          alt="MeGroup"
          width="50px"
        />
      </b-navbar-brand>
      <!-- </div> -->
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" style="margin-left: 5px;" is-nav>
        <b-navbar-nav>
          <!-- <b-nav-item to="/dashboard" v-if="dashboard_read">

            <i class="fas fa-chart-pie mr-2"></i>Dashboard
          </b-nav-item>
          <b-nav-item-dropdown
            right
            v-if="hoso_read || hoso_report || hoso_department"
          >
            <template slot="button-content">
              <i class="fas fa-users"></i>
              Employee Profile
          
            </template>
            <b-dropdown-item to="/hr_record?status=0" v-if="hoso_read"
              >Employee Profile
         
            </b-dropdown-item>
            <b-dropdown-item to="/employee_report" v-if="hoso_report"
              >Employee Profile Report
        
            </b-dropdown-item>

            <b-dropdown-item to="/department" v-if="hoso_department"
              >Department/Branch
       
            </b-dropdown-item>
   
          </b-nav-item-dropdown>
          <b-nav-item to="/cong_viec" v-if="task_read">
            <i class="fas fa-tasks mr-2"></i>Tasks
   
          </b-nav-item>
          <b-nav-item-dropdown
            right
            v-if="
              project_contract_read ||
                project_customer_read ||
                project_bonus_read ||
                project_report
            "
          >
            <template slot="button-content">
              <i class="fas fa-server"></i>
    
              Job
            </template>
      
            <b-dropdown-item to="/contract" v-if="project_contract_read"
              >Contract
        
            </b-dropdown-item>
            <b-dropdown-item to="/project" v-if="project_bonus_read"
              >Bonus</b-dropdown-item
            >
            <b-dropdown-item to="/customer" v-if="project_customer_read"
              >Customer
         
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item to="/booking" v-if="meetingevent_read">
            <i class="far fa-calendar-alt mr-2"></i>Booking
          </b-nav-item>
          <b-nav-item-dropdown right v-if="qtake_read">
            <template slot="button-content">
              <i class="far fa-calendar-alt mr-2"></i>
              Qtake
            </template>
            <b-dropdown-item
              to="/qtake_booking"
              v-if="qtake_read || production_read"
              >Booking</b-dropdown-item
            >
            <b-dropdown-item to="/qtake_project" v-if="qtake_project"
              >Project</b-dropdown-item
            >
            <b-dropdown-item to="/qtake_cost" v-if="qtake_cost"
              >Cost</b-dropdown-item
            >
            <b-dropdown-item to="/qtake_report" v-if="qtake_report"
              >Report</b-dropdown-item
            >
          </b-nav-item-dropdown>
          <b-nav-item-dropdown
            right
            v-if="
              leaveschedule_read || leaveschedule_report || timeoff_management
            "
          >
            <template slot="button-content">
              <i class="fas fa-briefcase mr-2"></i>Timekeeping
   
            </template>
            <b-dropdown-item v-if="timeoff_management" to="/time_off_management"
              >Time-off Management
        
            </b-dropdown-item>
            <b-dropdown-item v-if="leaveschedule_read" to="/lich_nghi_phep"
              >Employee Timekeeping

            </b-dropdown-item>
            <b-dropdown-item
              v-if="leaveschedule_report"
              to="/bao_cao_lich_nghi_phep"
              >Annual leave
    
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown right v-if="salary_read">
            <template slot="button-content">
              <i class="fas fa-hand-holding-usd mr-2"></i>
              Salary
           
            </template>
            <b-dropdown-item to="/tinh_luong" v-if="salary_read">
              Salary Confirmation
        
            </b-dropdown-item>
            <b-dropdown-item to="/bang_luong" v-if="salary_read">
              Payroll
       
            </b-dropdown-item>
            <b-dropdown-item to="/bang_luong_tong_hop" v-if="salary_read">
              General Payroll
         
            </b-dropdown-item>

            <b-dropdown-item to="/lich_su_thay_doi_luong" v-if="salary_read">
              Salary History
          
            </b-dropdown-item>
            <b-dropdown-item to="/thong_ke_luong_phu_cap" v-if="salary_read">
              Salary and Allowances Statistic
      
            </b-dropdown-item>
          </b-nav-item-dropdown>
      
          <b-nav-item-dropdown right v-if="asset_read || asset_report_read">
            <template slot="button-content">
              <i class="fas fa-hdd"></i>
              Assets
    
            </template>
            <b-dropdown-item to="/asset" v-if="asset_read"
              >Assets Management
          
            </b-dropdown-item>
            <b-dropdown-item to="/asset_report" v-if="asset_report_read"
              >Assets Report
      
            </b-dropdown-item>
          </b-nav-item-dropdown>
       
          <b-nav-item
            v-if="auth != null && timeoff_request_read"
            :to="`/time_off_request/${this.auth.name}`"
          >
            <i class="fas fa-file-alt mr-2"></i>Time-off Request
          </b-nav-item>
         
      
          <b-nav-item to="/p_PitchSales" v-if="pitch_god || pitch_normal">
            <i class="fas fa-comments-dollar mr-2"></i>Pitch Record
          </b-nav-item>

          <b-nav-item to="/pitching" v-if="director_view">
            <i class="fas fa-video mr-2"></i>Director
          </b-nav-item>
          <b-nav-item-dropdown right v-if="director_system || system_read || pitch_system" >
            <template slot="button-content" >
              <i class="fas fa-user-shield mr-2"></i>
              System
            </template>
            <b-dropdown-item v-if="system_read"
              to="/account"
             
              >HR System</b-dropdown-item
            >
            <b-dropdown-item v-if="director_system"
              to="/director_kind"
             
              >Director System</b-dropdown-item
            >
            <b-dropdown-item v-if="pitch_system"
              to="/p_Group"
             
              >Pitch System</b-dropdown-item
            >
          
        
          </b-nav-item-dropdown> -->
          <b-nav-item-dropdown
            id="dropdown-left"
            text="Left align"
            v-if="
              hoso_read ||
                hoso_report ||
                hoso_department ||
                asset_read ||
                asset_report_read ||
                salary_read
            "
          >
            <template slot="button-content">
              HRM+
            </template>

            <b-dropdown
              v-if="hoso_read || hoso_report || hoso_department"
              id="dropdown"
              dropright
              text="Employee"
              class="dropdown-lv"
              variant="bg-transparent"
            >
              <b-dropdown-item
                @click="closeDropdown"
                to="/hr_record?status=0"
                v-if="hoso_read"
                >Employee Profile</b-dropdown-item
              >

              <b-dropdown-item
                @click="closeDropdown"
                to="/employee_report"
                v-if="hoso_report"
                >Employee Report</b-dropdown-item
              >
              <b-dropdown-item
                @click="closeDropdown"
                to="/department"
                v-if="hoso_department"
                >Department/Branch</b-dropdown-item
              >
            </b-dropdown>
            <b-dropdown
              v-if="asset_read || asset_report_read"
              id="dropdown"
              dropright
              text="Asset"
              class="dropdown-lv"
              variant="bg-transparent"
            >
              <b-dropdown-item
                @click="closeDropdown"
                to="/asset"
                v-if="asset_read"
                >Asset Management</b-dropdown-item
              >
              <b-dropdown-item
                @click="closeDropdown"
                to="/asset_report"
                v-if="asset_report_read"
                >Asset Report</b-dropdown-item
              >
            </b-dropdown>
            <b-dropdown
              v-if="
                leaveschedule_read || leaveschedule_report || timeoff_management
              "
              id="dropdown"
              dropright
              text="Timesheet"
              class="dropdown-lv"
              variant="bg-transparent"
            >
              <b-dropdown-item
                @click="closeDropdown"
                v-if="timeoff_management"
                to="/time_off_management"
                >Time-off Management</b-dropdown-item
              >
              <b-dropdown-item
                @click="closeDropdown"
                v-if="leaveschedule_read"
                to="/lich_nghi_phep"
                >Timesheet Export</b-dropdown-item
              >
              <b-dropdown-item
                @click="closeDropdown"
                v-if="leaveschedule_report"
                to="/bao_cao_lich_nghi_phep"
                >Annual leave</b-dropdown-item
              >
            </b-dropdown>
            <b-dropdown
              v-if="salary_read"
              id="dropdown"
              dropright
              text="Payroll"
              class="dropdown-lv"
              variant="bg-transparent"
            >
              <b-dropdown-item
                @click="closeDropdown"
                to="/tinh_luong"
                v-if="salary_read"
                >Payroll Confirmation</b-dropdown-item
              >
              <b-dropdown-item
                @click="closeDropdown"
                to="/bang_luong"
                v-if="salary_read"
                >Payroll Export</b-dropdown-item
              >
              <b-dropdown-item
                @click="closeDropdown"
                to="/bang_luong_tong_hop"
                v-if="salary_read"
                >Payroll Tracking</b-dropdown-item
              >
              <b-dropdown-item
                @click="closeDropdown"
                to="/lich_su_thay_doi_luong"
                v-if="salary_read"
                >Salary History</b-dropdown-item
              >
              <b-dropdown-item
                @click="closeDropdown"
                to="/thong_ke_luong_phu_cap"
                v-if="salary_read"
                >Salary and Allowances Statisticy</b-dropdown-item
              >
            </b-dropdown>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown
            right
            v-if="project_contract_read || project_customer_read || project_bonus_read || project_report"
          >
            <template slot="button-content">Project</template>

            <b-dropdown-item to="/contract" v-if="project_contract_read"
              >Contract</b-dropdown-item
            >
            <b-dropdown-item to="/project" v-if="project_bonus_read"
              >Bonus</b-dropdown-item
            >
            <b-dropdown-item to="/customer" v-if="project_customer_read"
              >Client/Agency</b-dropdown-item
            >
          </b-nav-item-dropdown>
          <b-nav-item-dropdown right>
            <template slot="button-content">Incentives</template>
            <b-dropdown-item to="/bonus_Sales">Sales Form</b-dropdown-item>
            <b-dropdown-item to="/bonus_Post">Shooting Form</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item
            v-if="auth != null && timeoff_request_read"
            :to="`/time_off_request/${this.auth.name}`"
          >
            Time-off Request
          </b-nav-item>

          <b-nav-item-dropdown right v-if="task_read">
            <template slot="button-content">Tasks</template>
            <b-dropdown-item to="/cong_viec" v-if="task_read"
              >Tasks</b-dropdown-item
            >
            <b-dropdown-item>Objective & Review </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item to="/booking" v-if="meetingevent_read">
            Booking
          </b-nav-item>

          <b-nav-item-dropdown right>
            <template slot="button-content">Qtake</template>
            <b-dropdown-item
              to="/qtake_booking"
              v-if="qtake_read || production_read"
              >Booking</b-dropdown-item
            >
            <b-dropdown-item to="/qtake_project" v-if="qtake_project"
              >Project</b-dropdown-item
            >
            <b-dropdown-item to="/qtake_cost" v-if="qtake_cost"
              >Cost</b-dropdown-item
            >
            <b-dropdown-item to="/qtake_report" v-if="qtake_report"
              >Report</b-dropdown-item
            >
          </b-nav-item-dropdown>

          <b-nav-item to="/p_PitchSales" v-if="pitch_god || pitch_normal">
            Pitch Record
          </b-nav-item>

          <b-nav-item to="/pitching" v-if="director_view">
            Director
          </b-nav-item>

          <b-nav-item-dropdown
            right 
            v-if="director_system || system_read || pitch_system || bonus_system">
            <template slot="button-content">System</template>
            <b-dropdown-item v-if="system_read" to="/account"
              >HR System</b-dropdown-item
            >
            <b-dropdown-item v-if="director_system" to="/director_kind"
              >Director System</b-dropdown-item
            >
            <b-dropdown-item v-if="pitch_system" to="/p_Group"
              >Pitch System</b-dropdown-item
            >
            <b-dropdown-item to="/Bonus_blankPage" v-if="bonus_system"
              >Incentives System</b-dropdown-item
            >
          </b-nav-item-dropdown>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown
            right
            v-if="auth != null && isNotBookingMenu() && isNotPitchMenu()"
          >
            <template v-slot:button-content>
              <i class="fas fa-building mr-2"></i>
              {{
                departmentid == -1
                  ? ""
                  : departmentid == 0
                  ? "Tất cả"
                  : department.madonvi
              }}
            </template>
            <b-dropdown-item
              v-if="departments.length > 1"
              @click.prevent="changeDepartment(0)"
              >Tất cả</b-dropdown-item
            >
            <b-dropdown-item
              v-for="department in departments"
              :key="department.id"
              @click.prevent="changeDepartment(department.id)"
              >{{ department.tendonvi }}</b-dropdown-item
            >
          </b-nav-item-dropdown>
          <b-nav-item-dropdown right v-if="auth != null">
            <!-- Using 'button-content' slot -->
            <template v-slot:button-content>
              <i class="fas fa-user-circle fa-fw mr-2"></i>
              {{ auth.name }}
            </template>
            <b-dropdown-item
              v-if="hoso_update || hoso_read"
              @click.prevent="go_to_googledrive"
            >
              <i class="fas fa-list"></i>
              User manual
            </b-dropdown-item>
            <b-dropdown-item
              v-if="!hoso_isSysAcc"
              @click.prevent="changePassword"
            >
              <i class="fas fa-key fa-xs"></i>
              Change password
            </b-dropdown-item>
            <b-dropdown-item v-if="isAdmin" @click.prevent="resetPassword">
              <i class="fas fa-key fa-xs"></i>
              Reset password
            </b-dropdown-item>
            <b-dropdown-item @click.prevent="logout">
              <i class="fas fa-sign-in-alt fa-xs"></i>
              Log out
            </b-dropdown-item>
            <b-dropdown-item v-if="auth.name == 'admin'">
              <i class="fas fa-sign-in-alt fa-xs"></i>
              V1.0.12
              <!--
                V1.0.6: Add Search Bar into Position Page
                V1.0.7: Fix Error LocalTime in Employee Profile (employee + contracts)
                -->
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <router-view :key="$route.fullPath" />

    <!-- /#wrapper -->
    <!-- Scroll to Top Button-->
    <a class="scroll-to-top rounded" href="#page-top">
      <i class="fas fa-angle-up"></i>
    </a>

    <auth-modal :show="auth == null && isNotTimeOffRequestMenu" />
  </div>
</template>

<script>
import AuthModal from "./components/Login/AuthModal";
import axios from "axios";
export default {
  name: "app",
  components: {
    AuthModal,
  },

  computed: {
    //Permission: SysUser can not change password
    bonus_ps_view_all() {
      return this.$store.getters.hasPermission("bonus_ps_view_all");
    },
    bonus_ps_view() {
      return this.$store.getters.hasPermission("bonus_ps_view");
    },
    bonus_sf_view_all() {
      return this.$store.getters.hasPermission("bonus_sf_view_all");
    },
    bonus_sf_view() {
      return this.$store.getters.hasPermission("bonus_sf_view");
    },
    bonus_system() {
      return this.$store.getters.hasPermission("bonus_system");
    },
    director_system() {
      return this.$store.getters.hasPermission("director_system");
    },
    director_view() {
      return this.$store.getters.hasPermission("director_view");
    },
    pitch_system() {
      return this.$store.getters.hasPermission("pitch_system");
    },
    pitch_normal() {
      return this.$store.getters.hasPermission("pitch_normal");
    },
    pitch_god() {
      return this.$store.getters.hasPermission("pitch_god");
    },
    hoso_isSysAcc() {
      return this.$store.getters.hasPermission("hoso_isSysAcc");
    },
    auth() {
      return this.$store.state.auth;
    },
    viewHeThong() {
      return this.$store.getters.hasPermission("hethong_view");
    },
    hoso_read() {
      return this.$store.getters.hasPermission("hoso_read");
    },
    hoso_update() {
      return this.$store.getters.hasPermission("hoso_update");
    },
    hoso_report() {
      return this.$store.getters.hasPermission("hoso_report");
    },
    hoso_report5() {
      return this.$store.getters.hasPermission("hoso_report5");
    },
    hoso_report_all() {
      return this.$store.getters.hasPermission("hoso_report_all");
    },
    hoso_department() {
      return this.$store.getters.hasPermission("department_read");
    },
    task_read() {
      return this.$store.getters.hasPermission("task_read");
    },
    leaveschedule_read() {
      return this.$store.getters.hasPermission("leaveschedule_read");
    },
    leaveschedule_report() {
      return this.$store.getters.hasPermission("leaveschedule_report");
    },
    asset_read() {
      return this.$store.getters.hasPermission("asset_read");
    },
    asset_report_read() {
      return this.$store.getters.hasPermission("asset_report_read");
    },
    system_read() {
      return this.$store.getters.hasPermission("system_read");
    },
    // customercontract_read() {
    //   return this.$store.getters.hasPermission("customercontract_read");
    // }, //Quyen 01.Xem Menu Quản lý Dự an
    project_contract_read() {
      return this.$store.getters.hasPermission("project_contract_read");
    },
    project_customer_read() {
      return this.$store.getters.hasPermission("project_customer_read");
    },
    project_bonus_read() {
      return this.$store.getters.hasPermission("project_bonus_read");
    },
    project_report() {
      return this.$store.getters.hasPermission("project_report");
    }, //Quyen 01. Xem Menu Báo cáo dự án
    salary_read() {
      return this.$store.getters.hasPermission("salary_read");
    },
    meetingevent_read() {
      return this.$store.getters.hasPermission("meetingevent_read");
    },
    qtake_read() {
      return this.$store.getters.hasPermission("qtake_read");
    },
    qtake_project() {
      return this.$store.getters.hasPermission("qtake_project");
    },
    qtake_cost() {
      return this.$store.getters.hasPermission("qtake_cost");
    },
    qtake_report() {
      return this.$store.getters.hasPermission("qtake_report");
    },
    departments() {
      return this.$store.getters.departments;
    },
    department() {
      return this.$store.getters.department;
    },
    departmentid() {
      return this.$store.getters.departmentid;
    },
    dashboard_read() {
      return this.$store.getters.hasPermission("dashboard_read");
    },
    //#region Master Schedule: Update 02/06/2022: Production permission - continue update 28/10/2022 add production_admin
    production_read() {
      return this.$store.getters.hasPermission("production_read");
    },
    production_create() {
      return this.$store.getters.hasPermission("production_create");
    },
    production_update() {
      return this.$store.getters.hasPermission("production_update");
    },
    production_delete() {
      return this.$store.getters.hasPermission("production_delete");
    },
    production_admin() {
      return this.$store.getters.hasPermission("production_admin");
    },
    //#endregion

    //#region Time-Off Register
    /*UPDATE 31/10/2022: add time-off request permission*/
    timeoff_request_read() {
      return this.$store.getters.hasPermission("timeoff_request_read");
    },
    /*UPDATE 09/08/2023: add time-off management permission*/
    timeoff_management() {
      return this.$store.getters.hasPermission("timeoff_management");
    },
    isNotTimeOffRequestMenu() {
      return !["/confirm_approval/:id/:line_manager_id/:confirm"].includes(
        this.$router.history.current.matched[0]["path"]
      );
    },
    //#endregion
    //UPDATE 06/10/2023: Use Reset password for User
    isAdmin() {
      return this.$store.getters.hasPermission("system_read");
    },
  },

  methods: {
    logout() {
      this.$store.commit("logout");
      delete axios.defaults.headers.common["Authorization"];
      this.$router.push("/login");
    },
    go_to_googledrive() {
      window
        .open(
          "https://docs.google.com/document/d/1WgWeWUwYKmDkMi5wYaifFW6JrzzEmQmk/edit?usp=sharing&ouid=109069971903038194136&rtpof=true&sd=true",
          "_blank"
        )
        .focus();
    },
    closeDropdown(event) {
      let dropdown = event.target.closest(".dropdown-menu.show");
      if (dropdown) {
        let dropdownToggle = dropdown.previousElementSibling;
        if (
          dropdownToggle &&
          dropdownToggle.classList.contains("dropdown-toggle")
        ) {
          dropdownToggle.click();
        }
      }
    },
    changeDepartment(id) {
      const payload = {
        refreshToken: this.$store.state.auth.refreshToken,
        departmentid: id,
      };
      axios
        .post("/api/authentication/refresh", payload)
        .then((response) => {
          const auth = response.data;
          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${auth.accessToken}`;
          this.$store.commit("loginSuccess", auth);
          this.$router.go();
        })
        .catch((error) => {
          this.$store.commit("logout");
          this.$router.push({ path: "/" });
          delete axios.defaults.headers.common["Authorization"];
        });
    },
    changePassword() {
      this.$router.push(`/change_password/${this.$store.state.auth.accountId}`);
    },
    resetPassword() {
      this.$router.push(`/reset_password/${this.$store.state.auth.accountId}`);
    },
    //#region Check Menu
    isNotBookingMenu() {
      var router_his = this.$router.history.current.matched[0]; //First call router history is empty
      if (!router_his) return true;
      return ![
        "/booking",
        "/booking_contract",
        "/booking_managerment",
        "/production_booking",
        "/qtake_booking",
        "/qtake_department",
        "/qtake_price",
        "/qtake_project",
        "/qtake_cost",
        "/qtake_report",
      ].includes(router_his["path"]);
    },
    isNotPitchMenu() {
      return ![
        "/p_PitchSales",
        "/p_PicklistMenu",
        "/p_Permission",
        "/p_Group",
        "/p_Users",
        "/director_Permission",
        "/director_kind",
        "/director_Group",
        "/pitching",
        "/director_ratevalue",
      ].includes(this.$router.history.current["path"]);
    },
    //#endregion
  },
};
</script>

<style>
html,
body {
  height: 100vh;
  overflow: hidden;
}
/* html::-webkit-scrollbar {
  display: none;
} */
body.modal-open {
  overflow: hidden;
  padding-right: 0 !important;
}
div.modal-content {
  border: 0;
}
/* div#__BVID__676 {
  padding-right: 0 !important;
} */
div#date_modal {
  padding-right: 0 !important;
}

.mydiv {
  padding: 0.2em 1em 0.1em 1em;
  color: #000;
  border-radius: 10px;
  background-color: #fde3c1;
  height: 40px;
}
nav.navbar.mainbar.navbar-dark {
  height: 56px;
}
button.btn-sm.border-0.btn-info:focus,
:focus-visible {
  outline: none;
}
@media (max-width: 992px) {
  nav.navbar.mainbar.navbar-dark.navbar-expand-lg {
    height: unset;
  }
}
.navbar-dark .navbar-nav a.nav-link {
  color: #fff;
}
.sidebar.navbar-nav {
  background-color: #fff;
}
.sidebar .nav-item a.nav-link {
  color: #000000;
  fill: #000000; /* color for <svg>*/
  width: 76px;
  min-width: 76px;
  max-width: 76px;
  padding: 7px 0px 7px 0px;
  margin: 5px;
}

.sidebar .nav-item a.nav-link:hover {
  color: #b7b7b7;
  fill: #b7b7b7;
  background-color: #fff;
}
.navbar-dark .navbar-nav a.nav-link:hover,
.navbar-dark .navbar-nav a.nav-link:focus {
  color: #b7b7b7;
}
.sidebar a.nav-link.router-link-exact-active.router-link-active {
  background-color: #84c3d5;
  fill: #fffd; /* color for <svg>*/
  color: #fff;
  padding: 7px 0px 7px 0px;
  margin: 5px;
}
a.dropdown-item:hover,
.dropdown-item:focus {
  color: #fff;
  text-decoration: none;
  background-color: #84c3d5;
}
/* // @THANH: CHINH MAU VUECAL*/
.vuecal__header {
  background-color: #f4f7fc;
}
.vuecal__body {
  background-color: #f4f7fc;
}
.vuecal__flex.vuecal__cells.month-view {
  background-color: #fff;
}
.vuecal__bg.vuecal__flex {
  height: 780px;
}
.vuecal__bg.vuecal__flex::-webkit-scrollbar {
  display: none !important;
}

.vuecal__event {
  left: 1px;
  background-color: transparent;
}
.vuecal__cell:before {
  border: 1px dashed rgb(177 177 177);
}

.vuecal__cell--today .vuecal__cell-date div {
  background-color: #4f608c;
  color: #fff;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  width: 24px;
  margin: auto;
}
/* .vuecal__cell--today .vuecal__event-title {
  font-weight: bold;
} */
.vuecal__flex.vuecal__weekdays-headings {
  padding-right: 0px;
}
.vuecal__heading {
  padding: 5px;
  height: 2.1em !important;
}
.vuecal__cell--today .vuecal__event * {
  font-weight: bold;
}
.vuecal__cell--today div#job_event {
  font-weight: 500;
}
.vuecal__cell-date {
  font-weight: bold;
}
.vuecal--month-view .vuecal__cell-content {
  min-height: 125.734px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.demo {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

.demo input {
  width: 100%;
  padding: 0.5rem;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
}

.demo ul {
  width: 100%;
  color: rgba(30, 39, 46, 1);
  list-style: none;
  margin: 0;
  padding: 0.5rem 0 0.5rem 0;
}

.demo li {
  margin: 0 0 0 0;
  border-radius: 5px;
  padding: 0.75rem 0 0.75rem 0.75rem;
  display: flex;
  align-items: center;
}

.demo li:hover {
  cursor: pointer;
}

.demo .autosuggest-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.demo #autosuggest {
  width: 500px;
  display: block;
}

.demo .autosuggest__results-item--highlighted {
  background-color: rgba(51, 217, 178, 0.2);
}

.demo .autosuggest__results-container {
  position: fixed;
  z-index: 100;
  width: 500px;
  background: #ededed;
}

.vpd-input-group input {
  border: 1px solid #dadada !important;
  border-left: none !important;
  border-radius: 0.25rem !important;
}
.vpd-icon-btn {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.button--pandora {
  font-size: 16px !important;
  color: white;
  background-color: #6c757d;
  border: 1px solid #000;
  border-radius: 5px;
  transform: translate3d(-2px, -4px, 0);
  transition: transform 0.3s cubic-bezier(0.7, 0, 0.2, 1);
}

.button--pandora:hover {
  transform: translate3d(-5px, -7px, 0);
  background-color: #fff;
  color: #000;
}

.button--pandora:focus {
  background-color: #84c3d5;
  outline: none;
}

.button--pandora_bg {
  font-size: 16px !important;
  color: white;
  background-color: #17a2b8;
  border: 1px solid #000;
  border-radius: 5px;
  transform: translate3d(-2px, -4px, 0);
  transition: transform 0.3s cubic-bezier(0.7, 0, 0.2, 1);
}

.button--pandora_bg:hover {
  transform: translate3d(-5px, -7px, 0);
  background-color: #dfd6d6;
  color: #000;
}

.button--pandora_bg:focus {
  background-color: #84c3d5;
  outline: none;
}

.table-sm td.text-center {
  padding: 5px;
}

.dropdown-header {
  font-weight: bold;
  color: #5384d1 !important;
  font-size: 15px !important;
}

.dropdown-item {
  font-size: 16px;
  /* Adjust the font size as needed */
}

#head-dropdown button {
  color: rgba(255, 255, 255, 0.5);
}

#head-dropdown > .dropdown-menu {
  position: absolute;
  top: 38px;
}

#dropdown button {
  color: #16181b;
  padding: 0.25rem 58px 0.25rem 1.5rem;
  width: 158px;
  text-align: left;
}

#dropdown > .dropdown-menu {
  position: absolute;
  left: 156px;
  width: 270px;
}

.dropdown-lv:hover > .dropdown-toggle + .dropdown-menu {
  display: block;
  right: 0;
}

#dropdown:hover > .dropdown-toggle {
  background-color: #f8f9fa;
}

#dropdown > .dropdown-toggle::after {
  content: "\f105"; /* Mã Unicode cho mũi tên ngang trong Font Awesome */
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  position: absolute;
  right: 0;
  top: 50%;
  right: 30px;
  transform: translateY(-50%);
}
#head-dropdown:hover > .dropdown-toggle {
  color: rgba(255, 255, 255, 0.8);
}
</style>
